/*
  Live-Warenkorb (Okt 2026). Die GPE-App ändert die Shopify-Preise mit dem Goldkurs. Ein geöffneter Warenkorb
  (Seite /cart oder Seitenleiste) zeigt sonst den Preis vom Laden der Seite – an der Kasse gilt aber schon der neue.
  Lösung (wie ma-preis-live.js, kein fester Takt): nach einem neuen App-Kurs (Ereignis „ma:kurs“ mit neuem Zeitstempel,
  dann nach 20 s und 90 s nachfassen) und beim Zurückkommen zur Seite /cart.js prüfen. Hat sich der Stückpreis einer
  Position geändert, wird der Warenkorb neu gezeichnet (gleicher Weg wie das Theme: ?section_id=cart-helper) und darüber
  steht „Preise aktualisiert um HH:MM Uhr“. Mengenänderungen durch den Kunden lösen keinen Hinweis aus.
*/
(() => {
  const NACHFASSEN = [20, 90]; // Sekunden nach neuem App-Kurs (die App setzt die Produktpreise zeitversetzt)
  let snap = null, appAt = null, lastCheck = 0, busy = false, timers = [];
  const zeit = d => d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });

  const stand = items => Object.fromEntries(items.map(i => [i.key, i.price]));

  async function check() {
    if (busy) return;
    busy = true; lastCheck = Date.now();
    try {
      const r = await fetch('/cart.js?_=' + Date.now(), { cache: 'no-store' });
      const c = await r.json();
      const neu = stand(c.items || []);
      const alt = snap;
      snap = neu;
      if (!alt || !c.item_count) return;
      const geaendert = Object.keys(neu).some(k => k in alt && alt[k] !== neu[k]);
      if (geaendert) await redraw();
    } catch (e) { /* Netz weg: beim nächsten Anlass erneut */ }
    finally { busy = false; }
  }

  async function redraw() {
    const forms = document.querySelectorAll('[id="AjaxCartForm"]');
    const subs = document.querySelectorAll('[id="AjaxCartSubtotal"]');
    if (!forms.length && !subs.length) return;
    const r = await fetch('?section_id=cart-helper&_=' + Date.now(), { cache: 'no-store' });
    const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
    const f = doc.getElementById('AjaxCartForm'), s = doc.getElementById('AjaxCartSubtotal');
    if (f) forms.forEach(el => {
      el.innerHTML = f.innerHTML;
      if (typeof el.ajaxifyCartItems === 'function') el.ajaxifyCartItems();
      if (typeof window.preloadImages === 'function') window.preloadImages(el);
    });
    if (s) subs.forEach(el => { el.innerHTML = s.innerHTML; });
    hint();
  }

  function hint() {
    if (!document.getElementById('mwk-style')) {
      const st = document.createElement('style');
      st.id = 'mwk-style';
      st.textContent = '.mwk-hint{margin:0 0 12px!important;padding:8px 10px;border:1px solid #e7e1d3;border-radius:8px;background:#faf8f3;color:#030331;font-size:.82rem;line-height:1.4;text-align:left}';
      document.head.appendChild(st);
    }
    const txt = `Preise aktualisiert um ${zeit(new Date())} Uhr – der Goldkurs hat sich geändert.`;
    document.querySelectorAll('[id="AjaxCartSubtotal"]').forEach(el => {
      let h = el.querySelector('.mwk-hint');
      if (!h) { h = document.createElement('p'); h.className = 'mwk-hint'; h.setAttribute('role', 'status'); el.prepend(h); }
      h.textContent = txt;
    });
  }

  const start = () => {
    check(); // Ausgangsstand
    document.addEventListener('ma:kurs', e => {
      const d = e.detail;
      if (!d || d.source !== 'GPE-App' || !d.at) return;
      const at = new Date(d.at);
      if (appAt && at.getTime() === appAt.getTime()) return;
      const first = !appAt;
      appAt = at;
      if (first) return;
      timers.forEach(clearTimeout);
      check();
      timers = NACHFASSEN.map(s => setTimeout(check, s * 1000));
    });
    const back = () => { if (!document.hidden && Date.now() - lastCheck > 15000) check(); };
    document.addEventListener('visibilitychange', back);
    window.addEventListener('pageshow', e => { if (e.persisted) back(); });
    // Zum Testen und für andere Skripte
    window.MAWarenkorb = { check, redraw, hint, get stand() { return snap; }, set stand(v) { snap = v; } };
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
